var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hyCheckboxGroup',[_c('hy-checkbox'),_c('hy-checkbox'),_c('hy-checkbox'),_c('hy-checkbox'),_c('hy-checkbox'),_c('hy-checkbox'),_c('hy-checkbox')],1),_c('hy-check')],1)}
var staticRenderFns = []

export { render, staticRenderFns }